import { createFileRoute } from '@tanstack/react-router'

import { itemMasterApi } from '@/features/inventory/api/item-master-api'
import { ItemMasterFormPage } from '@/features/inventory/components/item-master-form-page'

export const Route = createFileRoute('/_app/inventory/master/$id/update')({
  loader: async ({ params, context }) => {
    const { id } = params
    const { data } = await context.qc.ensureQueryData(
      itemMasterApi.detail.query({ params: { id } })
    )

    return {
      crumb: data.item.name,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <ItemMasterFormPage mode='update' id={id} />
}
